var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex mr-8"},[_c('vs-button',{directives:[{name:"can",rawName:"v-can",value:('view-customer-support'),expression:"'view-customer-support'"}],attrs:{"icon-pack":"feather","icon":"icon-external-link","color":"success","type":"border"},on:{"click":_vm.onClickSupportApp}},[_vm._v("Support App")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }